/**
 * 選択中の検索条件タグIDを表示用のラベルに変換する。
 * マスタに存在しないID（マスタ更新前のURLクエリなど）は表示から除外する。
 */
export const buildSearchConditionLabel = (
  tagIds: Array<number> | undefined | null,
  tagIdToNameMap: Record<number, string>
): string =>
  (tagIds ?? [])
    .map((id) => tagIdToNameMap[id])
    .filter(Boolean)
    .join("、");
